import { useMutation } from '@tanstack/react-query';
import { POST, POST_REGISTER_INFO } from '../../../services';
import { closeLoading, openAlert, openLoading } from '../../../components/alert/hooks';
import { navigateReplaceTo } from '../../../utils/navigation';
import { MONITOR_LARK } from '../../../helpers/lark';
import { InsertWarranty } from '../../../resources/payload';
import { ROUTES_PATH } from '../../../resources/routes-name';

export const useInsertWarranty = () =>
  useMutation({
    mutationFn: async (values) => {
      openLoading();
      const formData = new FormData();
      const payload = InsertWarranty(values);

      Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });
      const response = await POST(POST_REGISTER_INFO(), formData);
      closeLoading();
      return response;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'ลงทะเบียนรับประกันสินค้าสำเร็จ',
      });
      navigateReplaceTo({ pathname: ROUTES_PATH.ROUTE_HOME.PATH });
    },
    onError: (err) => {
      const msgErr =
        err && err?.message == 'NETWORK_ERROR'
          ? 'ลงทะเบียนรับประกันสินค้าไม่สำเร็จ \nหากท่านใช้ภาพจากการอัพโหลดลงทะเบียนไม่สำเร็จ\nให้ท่านเปลี่ยนมาใช้การถ่ายภาพแทน\nขออภัยในความไม่สะดวกคะ'
          : err?.message;
      openAlert({
        model: 'message',
        type: 'error',
        message: msgErr,
      });
      MONITOR_LARK({
        module: 'หน้าลงทะเบียนรับประกัน',
        message: `${POST_REGISTER_INFO()} : ลงทะเบียนรับประกันสินค้าไม่สำเร็จ!!`,
        error: err,
      });
    },
  });
